import { render, staticRenderFns } from "./TeamMemberDetails.vue?vue&type=template&id=2d2b0502&scoped=true&"
import script from "./TeamMemberDetails.vue?vue&type=script&lang=js&"
export * from "./TeamMemberDetails.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberDetails.vue?vue&type=style&index=0&id=2d2b0502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b0502",
  null
  
)

export default component.exports